export const en = {
    "k_85a2ac6d": "CosId does not exist",
    "k_ffa5d2bf": "❌ Unable to find a dependent package for the specified version: {arg_0}",
    "k_20c05d43": "❌ Unable to find a dependent package for the specified version",
    "k_aa091d87": "❌ The requested dependency package version does not exist",
    "k_913cb600": "❌ The specified dependency cannot be found. Please check whether the package name is wrong",
    "k_afa3a043": "📦Installing dependency packages...",
    "k_ef816546": "❌ Dependent package installation failed",
    "k_6563763f": "⚡ Packaging dependent files...",
    "k_a8bff7e6": "❌ Packaging of dependent files failed",
    "k_dfd0126d": "❌ Dependent update failed",
    "k_daa8324c": "Processing...",
    "k_993229d6": "WUJI blue",
    "k_a9ccf0cc": "Dependency update failed, please check whether the external package name is wrong",
    "k_c8ddc835": "Cannot find the dependency \"{arg_0}\". Please check whether the package name is wrong",
    "k_bf230c2f": "Dependent loading",
    "k_95a6aab0": "Dependency updates...",
    "k_471da1da": "Language",
    "k_a6caebd4": "Failed to obtain language configuration:",
    "k_3059d24": "Dependent load complete",
    "k_2d329f7a": "[NpmLoader] Bundle failed:",
    "k_b8ca50f6": "Requesting remote packaging services...",
    "k_2f23bb54": "Packaging service request failed: {arg_0}",
    "k_48d6a55e": "Unable to read packaged service response",
    "k_e0d38530": "[NpmLoader] Failed to parse SSE data:",
    "k_363a3033": "The packaged service did not return a completion event",
    "k_b90195fd": "Processing failed",
    "k_21464e43": "Dependent loading completion",
    "k_431596e7": "Installing dependency packages...",
    "k_52a04cf3": "Building dependencies...",
    "k_f33c986f": "Build failures",
    "k_dea9626a": "Was successfully constructed",
    "k_3e3d6057": "Dependency upload failed: {arg_0}",
    "k_196eb698": "Packaging dependencies locally..."
};
